__webpack_require__.u = (chunkId) => {
		// gregfly func overload
		return "//static.overbetting2.ru/spb-stats/" + document.documentElement.lang + "/" + chunkId + ".js?v=1763676768";
};